import axios from "axios";
import { baseUrl, defaultAddErrorMessage, errorTranslate } from "../util";
import Swal from "sweetalert2";
import { ProductApiKey } from "../ApiKey/ProductApiKey";

export const createDuplicateProduct = ({
  id,
  triggerInvalidate,
  setErrorMessage = function () {
    return;
  },
  use_swal = false,
}) => {
  const { duplicateProduct } = ProductApiKey;
  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + id + "/duplicate-product",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      triggerInvalidate(duplicateProduct);
      setErrorMessage();
    })
    .catch(function (error) {
      setErrorMessage(error.response.data);
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};
